import { Directive, HostListener, input } from '@angular/core';

@Directive({
  selector: '[appRfcValidator]',
  standalone: true
})
export class RfcValidatorDirective {
  isComercial = input.required();
  allowBoth = input<boolean>(false);
  @HostListener('input', ['$event'])
  onInput(event: any) {
    const maxL = this.allowBoth() ? 13 : this.isComercial() ? 12 : 13;
    const input = event.target;
    const cleanValue = input.value.toUpperCase().replace(/[^A-ZÑ&0-9]/g, '');
    if (cleanValue) {
      input.value = (input.value?.length <= maxL) ? cleanValue : cleanValue.split('').slice(0, cleanValue.length - 1).join('');
    } else {
      input.value = cleanValue;
    }
  }
}
